import { useTranslation } from "react-i18next";
import React, { useEffect, useState, useRef } from "react";
import "./pncNew.css";
import AboutModal from "./Modals/AboutModal";
import FeedbackModal from "./Modals/FeedbackModal";
import DeleteConfirmationModal from "./Modals/DeleteConfirmationModal";
import Sidebar from "./Sidebar/Sidebar";
import Header from "./Header/Header";
import Main from "./Main/Main";
import { CHAT_API_ENDPOINTS } from "../api/CHAT_API_ENDPOINTS.js";
import usFlag from "../assets/united-states.png";
import jpFlag from "../assets/japan.png";

const PncNew = () => {
  const { t, i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState("jp");
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const languageMenuRef = useRef(null);
  const [isChatStarted, setIsChatStarted] = useState(false);
  const [searchType, setSearchType] = useState("");
  const [searchInput, setSearchInput] = useState({
    vin: "",
    model: "",
    classification: "",
  });
  const [chatId, setChatId] = useState(null);
  const [groups, setGroups] = useState([]);
  const [subGroups, setSubGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");

  const [selectedGroupMainGroup, setSelectedGroupMainGroup] = useState("");
  const [selectedSubGroupMainGroup, setSelectedSubGroupMainGroup] =
    useState("");

  const [selectedSubGroup, setSelectedSubGroup] = useState("");
  const [isLoadingSubGroups, setIsLoadingSubGroups] = useState(false);
  const [vinError, setVinError] = useState("");
  const [isValidVin, setIsValidVin] = useState(false);

  const [isLoadingVin, setIsLoadingVin] = useState(false);
  const [vinResults, setVinResults] = useState(null);
  const [adjustedLineOffDate, setAdjustedLineOffDate] = useState("");
  const [catalogNo, setCatalogNo] = useState("");
  const [model, setModel] = useState("");
  const [classification, setClassification] = useState("");
  const [vinInput, setVinInput] = useState("");
  const vinTimeoutRef = useRef(null);
  const [modelInput, setModelInput] = useState("");
  const [classificationInput, setClassificationInput] = useState("");
  const [debounceTimer, setDebounceTimer] = useState(null);
  const [modelClassError, setModelClassError] = useState("");
  const [isValidModelClass, setIsValidModelClass] = useState(false);
  const [isLoadingModelClass, setIsLoadingModelClass] = useState(false);

  const [showMainGroupDropdown, setShowMainGroupDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [groupDropdownOpen, setGroupDropdownOpen] = useState(false);
  const [subGroupDropdownOpen, setSubGroupDropdownOpen] = useState(false);

  // New state variables for user messages
  const [userInput, setUserInput] = useState("");
  const [userMessages, setUserMessages] = useState([]);
  const [showUserPart, setShowUserPart] = useState(false);

  const [assistantMessages, setAssistantMessages] = useState([]);
  const [isThinking, setIsThinking] = useState(false);
  const [dots, setDots] = useState("");
  const [hideInitialMessages, setHideInitialMessages] = useState(false);
  const [showSearchParams, setShowSearchParams] = useState(false);
  const [askAnotherQueryClicked, setAskAnotherQueryClicked] = useState(false);
  const [showYesSelection, setShowYesSelection] = useState(false);

  const [conversationCycleId, setConversationCycleId] = useState(
    () => `cycle-${Date.now()}`
  );
  const [conversationHistory, setConversationHistory] = useState({});
  const [cycleId, setCycleId] = useState(0);
  const [messages, setMessages] = useState([]);
  const [userMessage, setUserMessage] = useState("");
  const [isAboutModalOpen, setIsAboutModalOpen] = useState(false);

  // Add new state variables for chat history
  const [chatHistory, setChatHistory] = useState([]);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const [historyError, setHistoryError] = useState("");

  const [selectedHistoryId, setSelectedHistoryId] = useState(null);
  const chatContainerRef = useRef(null);
  const messagesEndRef = useRef(null);

  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);

  // Add new state for managing the three-dots menu
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [pinnedChats, setPinnedChats] = useState([]);
  const dropdownRef = useRef(null);

  //Prompt Suggestions
  const [selectedPromptIndex, setSelectedPromptIndex] = useState(0);
  const [promptSuggestions, setPromptSuggestions] = useState([
    "What are the part numbers available?",
    "Give me all portal description along with there part number?",
    "Give me all part number whose quantity is more then one?",
    // "Give me the details for this vin/ model and classification ",
  ]);
  const [showPromptSuggestion, setShowPromptSuggestion] = useState(false);
  const [selectedPromptSuggestion, setSelectedPromptSuggestion] = useState("");
  const [showQueriesInChat, setShowQueriesInChat] = useState(false);

  const [isQueriesDropdownOpen, setIsQueriesDropdownOpen] = useState(false);
  const queriesDropdownRef = useRef(null);
  const [highlightedMessageId, setHighlightedMessageId] = useState(null);
  const [isSendButtonDisabled, setIsSendButtonDisabled] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [isLogoutDropdownOpen, setIsLogoutDropdownOpen] = useState(false);
  const logoutDropdownRef = useRef(null);

  const [isListening, setIsListening] = useState(false);
  const [speechRecognition, setSpeechRecognition] = useState(null);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteItemInfo, setDeleteItemInfo] = useState(null);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const [selectedPublication, setSelectedPublication] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [publicationNumber, setPublicationNumber] = useState("");
  const [hasValidationError, setHasValidationError] = useState(false);
  const [isViewingHistory, setIsViewingHistory] = useState(false);
  const [isProcessingChangeSelection, setIsProcessingChangeSelection] =
    useState(false);

  const languageOptions = [
    { code: "en", name: "English", flag: usFlag, speechCode: "en-US" },
    // { code: "hi-IN", name: "हिन्दी", flag: "🇮🇳", speechCode: "hi-IN" },
    { code: "jp", name: "Japanese", flag: jpFlag, speechCode: "ja-JP" }, // Fixed: use ja-JP for speech
  ];

  const handleValidationChange = (hasError) => {
    setHasValidationError(hasError);
  };

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  useEffect(() => {
    window.searchParametersCallback = (data) => {
      setSelectedPublication(data.selectedPublication);
      setSelectedCountry(data.selectedCountry);
      setSelectedMonth(data.selectedMonth);
      setSelectedYear(data.selectedYear);
      setPublicationNumber(data.publicationNumberInput);
    };

    return () => {
      delete window.searchParametersCallback;
    };
  }, []);

  const handleSelectionChange = () => {
    checkSendButtonStatus();
  };

  const checkSendButtonStatus = () => {
    if (isViewingHistory) {
      setIsSendButtonDisabled(true);
      return;
    }
    const hasUserInput = userInput.trim().length > 0;

    if (!hasUserInput) {
      setIsSendButtonDisabled(true);
      return;
    }

    if (hasValidationError) {
      setIsSendButtonDisabled(true);
      return;
    }

    const allFieldsFilled = areAllRequiredFieldsFilled();
    setIsSendButtonDisabled(!allFieldsFilled);

    if (searchType === "vin") {
      // VIN: need vin and publication name
      const hasValidVin = vinInput.trim().length > 0 && isValidVin;
      const hasPublication = selectedPublication !== null;
      setIsSendButtonDisabled(!(hasValidVin && hasPublication));
    } else if (searchType === "model") {
      // Model: need model, publication, country, and calendar (month/year)
      const hasValidModel = modelInput.trim().length > 0;
      const hasPublication = selectedPublication !== null;
      const hasCountry = selectedCountry !== null;
      const hasCalendar = selectedMonth !== null && selectedYear !== null;
      setIsSendButtonDisabled(
        !(hasValidModel && hasPublication && hasCountry && hasCalendar)
      );
    } else if (searchType === "publication") {
      // Publication Number: just need the publication number
      const hasPublicationNumber = publicationNumber.trim().length > 0;
      setIsSendButtonDisabled(!hasPublicationNumber);
    } else {
      setIsSendButtonDisabled(true);
    }
  };

  useEffect(() => {
    checkSendButtonStatus();
  }, [
    userInput,
    searchType,
    vinInput,
    isValidVin,
    modelInput,
    selectedPublication,
    selectedCountry,
    selectedMonth,
    selectedYear,
    publicationNumber,
    isViewingHistory,
    hasValidationError,
  ]);

  useEffect(() => {
    // Provide current search parameter values to SearchParameters component
    window.getSearchParametersCallback = () => {
      return {
        publicationNumber: publicationNumber,
        selectedPublication: selectedPublication,
        selectedCountry: selectedCountry,
        selectedMonth: selectedMonth,
        selectedYear: selectedYear,
      };
    };

    return () => {
      delete window.getSearchParametersCallback;
    };
  }, [
    publicationNumber,
    selectedPublication,
    selectedCountry,
    selectedMonth,
    selectedYear,
  ]);

  useEffect(() => {
    // Load language from localStorage on component mount
    const savedLanguage = localStorage.getItem('selectedLanguage') || 'jp';
    setSelectedLanguage(savedLanguage);
    i18n.changeLanguage(savedLanguage);

    // Listen for language changes from other pages
    const handleStorageChange = (e) => {
      if (e.key === 'selectedLanguage' && e.newValue) {
        setSelectedLanguage(e.newValue);
        i18n.changeLanguage(e.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [i18n]);

  // Handle click outside the dropdown menu to close it
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdownId(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        languageMenuRef.current &&
        !languageMenuRef.current.contains(event.target)
      ) {
        setShowLanguageMenu(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        queriesDropdownRef.current &&
        !queriesDropdownRef.current.contains(event.target)
      ) {
        setIsQueriesDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Function to check window size and set sidebar state
    const checkWindowSize = () => {
      const isLargeScreen = window.innerWidth >= 992;
      setIsSidebarOpen(isLargeScreen);
    };

    // Run once on initial component mount
    checkWindowSize();

    // Set up event listener for resize
    window.addEventListener("resize", checkWindowSize);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("resize", checkWindowSize);
    };
  }, []);

  useEffect(() => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (SpeechRecognition) {
      const recognition = new SpeechRecognition();

      recognition.continuous = true;
      recognition.interimResults = true;

      // Find the speech code for the selected language
      const currentLanguage = languageOptions.find(
        (lang) => lang.code === selectedLanguage
      );
      recognition.lang = currentLanguage ? currentLanguage.speechCode : "en-US";

      recognition.onstart = () => {
        setIsListening(true);
      };

      recognition.onresult = (event) => {
        const current = event.resultIndex;
        const transcript = event.results[current][0].transcript;
        const fullTranscript = Array.from(event.results)
          .map((result) => result[0].transcript)
          .join(" ");

        setUserInput(fullTranscript);

        if (fullTranscript.trim().length > 0 && selectedSubGroup) {
          setIsSendButtonDisabled(false);
        }
      };

      recognition.onerror = (event) => {
        console.error("Speech recognition error", event.error);
        if (event.error === "no-speech" && isListening) {
          try {
            setTimeout(() => {
              recognition.start();
            }, 100);
          } catch (e) {
            console.error("Failed to restart after no-speech error", e);
          }
        }
      };

      recognition.onend = () => {
        if (isListening) {
          try {
            recognition.start();
          } catch (e) {
            console.error("Failed to restart speech recognition", e);
            setIsListening(false);
          }
        } else {
          setIsListening(false);
        }
      };

      setSpeechRecognition(recognition);
    } else {
      console.warn("Speech recognition not supported in this browser");
    }
    return () => {
      if (speechRecognition) {
        speechRecognition.abort();
      }
    };
  }, [selectedLanguage]); // ADD selectedLanguage dependency

  useEffect(() => {
    // When language changes, update any existing initial messages
    if (messages.length > 0) {
      setMessages((prevMessages) =>
        prevMessages.map((msg) => {
          if (msg.isInitialMessage && msg.textKey) {
            return {
              ...msg,
              text: t(msg.textKey), // Update with new translation
            };
          }
          return msg;
        })
      );
    }
  }, [selectedLanguage, t]);

  // Update the toggle function to start/stop speech recognition
  // Replace the toggleSpeechRecognition function in your PncNew.jsx file with this:

  const toggleSpeechRecognition = () => {
    if (!speechRecognition) {
      console.warn("Speech recognition not supported");
      return;
    }

    if (isListening) {
      setIsListening(false);
      speechRecognition.stop();
    } else {
      // Update language before starting
      const currentLanguage = languageOptions.find(
        (lang) => lang.code === selectedLanguage
      );
      speechRecognition.lang = currentLanguage
        ? currentLanguage.speechCode
        : "en-US";

      setUserInput("");
      setIsListening(true);
      try {
        speechRecognition.start();
      } catch (e) {
        console.error("Failed to start speech recognition", e);
      }
    }
  };

  const handleLanguageChange = (langCode) => {
    if (isListening && speechRecognition) {
      speechRecognition.stop();
      setIsListening(false);
    }
    setSelectedLanguage(langCode);
    i18n.changeLanguage(langCode);
    localStorage.setItem('selectedLanguage', langCode); // Save to localStorage
    setShowLanguageMenu(false);
  };

  const toggleSidebar = () => {
    // Add a slight delay to make animation more noticeable
    document.querySelector(".sidebarPnc").classList.add("animating");
    const toggleButton = document.querySelector(
      ".historyIconPnc img.cursor-pointer"
    );
    if (toggleButton) {
      toggleButton.classList.toggle("toggle-open");
      toggleButton.classList.toggle("toggle-closed");
    }
    setIsSidebarOpen(!isSidebarOpen);
    setTimeout(() => {
      const sidebar = document.querySelector(".sidebarPnc");
      if (sidebar) sidebar.classList.remove("animating");
    }, 500);
  };

  const handleLogout = () => {
    // console.log("Logging out...");
    // localStorage.removeItem("user");
    localStorage.clear();
    sessionStorage.clear();

    // Redirect to login page or home page
    window.location.href = "/";
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        logoutDropdownRef.current &&
        !logoutDropdownRef.current.contains(event.target)
      ) {
        setIsLogoutDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelectPastQuery = (queryText) => {
    setIsQueriesDropdownOpen(false);
    const messageElements = document.querySelectorAll(".userPartPnc");

    let found = false;
    messageElements.forEach((element) => {
      const questionElement = element.querySelector(".questionPartPnc");
      if (
        questionElement &&
        questionElement.textContent.trim() === queryText.trim()
      ) {
        scrollToElement(element);
        found = true;
      }
    });

    if (!found) {
      messageElements.forEach((element) => {
        const questionElement = element.querySelector(".questionPartPnc");
        if (
          questionElement &&
          questionElement.textContent.includes(queryText.trim())
        ) {
          scrollToElement(element);
          found = true;
        }
      });
    }

    if (!found) {
      const userMessages = messages.filter(
        (msg) =>
          msg.sender === "user" && !msg.isUserFeedback && !msg.isYesOption
      );
      const targetIndex = userMessages.findIndex(
        (msg) => msg.text === queryText
      );

      if (targetIndex !== -1) {
        let userMessageCount = 0;

        for (let i = 0; i < messageElements.length; i++) {
          if (messageElements[i].querySelector(".questionPartPnc")) {
            if (userMessageCount === targetIndex) {
              scrollToElement(messageElements[i]);
              found = true;
              break;
            }
            userMessageCount++;
          }
        }
      }
    }
    if (!found) {
      // console.log("Could not find message with text:", queryText);
    }
  };

  useEffect(() => {
    if (searchType && isChatStarted) {
      const allFieldsFilled = areAllRequiredFieldsFilled();

      if (allFieldsFilled && !hasValidationError) {
        // Show initial message and prompt suggestions
        addInitialSystemMessage();
        setShowPromptSuggestion(true);

        // Set a random prompt index
        const randomIndex = Math.floor(
          Math.random() * promptSuggestions.length
        );
        setSelectedPromptIndex(randomIndex);
      } else {
        // Hide initial message and prompt suggestions
        setShowPromptSuggestion(false);
        // Remove initial message if it exists
        setMessages((prevMessages) =>
          prevMessages.filter((msg) => !msg.isInitialMessage)
        );
      }
    }
  }, [
    searchType,
    vinInput,
    isValidVin,
    modelInput,
    selectedPublication,
    selectedCountry,
    selectedMonth,
    selectedYear,
    publicationNumber,
    isChatStarted,
    hasValidationError,
  ]);

  const scrollToElement = (element) => {
    element.scrollIntoView({ behavior: "smooth", block: "center" });
    element.classList.add("highlight-message");
    setTimeout(() => {
      element.classList.remove("highlight-message");
    }, 2000);
  };

  const toggleFeedbackModal = () => {
    setIsFeedbackModalOpen(!isFeedbackModalOpen);
  };

  const toggleDropdown = (id, e) => {
    e.stopPropagation(); // Prevent event from bubbling up
    setActiveDropdownId((prevId) => (prevId === id ? null : id));
  };

  // Function to handle feedback submission
  const handleFeedbackSubmit = (feedbackData) => {
    // console.log("Feedback submitted:", feedbackData);
    alert("Thank you for your feedback!");
  };

  const handleStartChat = () => {
    if (isListening && speechRecognition) {
      speechRecognition.stop();
      setIsListening(false);
    }
    setUserInput("");

    setIsChatStarted(true);
    setChatId(null);
    setSelectedHistoryId(null);

    const newCycleId = `cycle-${Date.now()}`;
    setConversationCycleId(newCycleId);

    setShowSearchParams(true);

    // Create a search parameters entry to insert into the messages array
    const searchParamsEntry = {
      type: "searchParameters",
      timestamp: new Date(),
      cycleId: newCycleId,
      messageId: `${newCycleId}-search-params-${Date.now()}`,
      searchType: searchType,
      showSearchParams: true,
    };
    setMessages([searchParamsEntry]);

    setUserMessages([]);
    setAssistantMessages([]);
    setShowPromptSuggestion(false);
  };

  const toggleAboutModal = () => {
    setIsAboutModalOpen(!isAboutModalOpen);
  };

  const scrollToBottom = () => {
    try {
      if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop =
          chatContainerRef.current.scrollHeight;
      }
    } catch (error) {
      console.error("Error scrolling to bottom:", error);
    }
  };

  useEffect(() => {
    scrollToBottom();
    const timeoutId = setTimeout(() => {
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop =
          chatContainerRef.current.scrollHeight;
      }
    }, 100);

    const secondTimeoutId = setTimeout(() => {
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop =
          chatContainerRef.current.scrollHeight;
      }
    }, 500);

    return () => {
      clearTimeout(timeoutId);
      clearTimeout(secondTimeoutId);
    };
  }, [messages, isThinking, assistantMessages, userMessages]);

  useEffect(() => {
    if (!chatContainerRef.current) return;
    const observer = new MutationObserver(() => {
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop =
          chatContainerRef.current.scrollHeight;
      }
    });
    observer.observe(chatContainerRef.current, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    // console.log("Updated Messages:", messages);
  }, [messages]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setDots((prev) => (prev.length < 3 ? prev + "." : ""));
  //   }, 500);

  //   return () => clearInterval(interval);
  // }, []);
  const saveCurrentConversation = () => {
    setConversationHistory((prev) => ({
      ...prev,
      [conversationCycleId]: {
        userMessages: [...userMessages],
        assistantMessages: [...assistantMessages],
        searchType,
        searchInput: { ...searchInput },
        selectedGroup,
        selectedGroupMainGroup,
        selectedSubGroup,
        selectedSubGroupMainGroup,
        chatId,
      },
    }));
  };

  useEffect(() => {
    // console.log("chatId state updated:", chatId);
  }, [chatId]);

  useEffect(() => {
    if (userMessages.length > 0 || assistantMessages.length > 0) {
      saveCurrentConversation();
    }
  }, [userMessages, assistantMessages, conversationCycleId]);

  const handleFeedback = (index, response) => {
    setMessages((prevMessages) =>
      prevMessages.map((msg) => {
        if (msg.sender === "assistant" && !msg.hideFeedbackButtons) {
          return {
            ...msg,
            hideFeedbackButtons: true,
          };
        }

        // Hide YesSelection buttons
        if (msg.showYesSelection) {
          return {
            ...msg,
            hideButtons: true,
          };
        }

        // Hide Ask Another Query button
        if (msg.isFollowUp) {
          return {
            ...msg,
            showAskAnotherQueryButton: false,
          };
        }

        return msg;
      })
    );

    const updatedMessage = {
      ...assistantMessages[index],
      feedbackSubmitted: true,
      userFeedback: response,
      hideFeedbackButtons: true,
    };

    setMessages((prevMessages) =>
      prevMessages.map((msg) =>
        msg.messageId === updatedMessage.messageId ? updatedMessage : msg
      )
    );

    setAssistantMessages((prevAssistantMessages) =>
      prevAssistantMessages.map((msg, i) =>
        i === index ? updatedMessage : msg
      )
    );

    const feedbackMessage = {
      text: response, // "Yes" or "No"
      timestamp: new Date(),
      cycleId: conversationCycleId,
      messageId: `${conversationCycleId}-feedback-${Date.now()}`,
      sender: "user",
      isUserFeedback: true,
      referenceMessageId: assistantMessages[index]?.messageId,
      userFeedback: response,
    };

    setMessages((prevMessages) => {
      const newMessages = [...prevMessages, feedbackMessage];
      return newMessages;
    });

    // If the response is "Yes", show the YesSelection component
    if (response === "Yes") {
      const yesSelectionMessage = {
        timestamp: new Date(),
        cycleId: conversationCycleId,
        messageId: `${conversationCycleId}-yes-selection-${Date.now()}`,
        showYesSelection: true,
        optionSelected: false,
      };

      setMessages((prevMessages) => [...prevMessages, yesSelectionMessage]);
    }
    // If user says "No", insert FusoChatEndMessage into the array
    else if (response === "No") {
      const endMessage = {
        text: "Awesome! If you ever need more info, just start a new chat. Have a great day!",
        timestamp: new Date(),
        cycleId: conversationCycleId,
        messageId: `${conversationCycleId}-end-message-${Date.now()}`,
        sender: "assistant",
        isFollowUp: true,
        showAskAnotherQueryButton: true,
      };

      // Add the end message to the messages array
      setMessages((prevMessages) => [...prevMessages, endMessage]);
    }

    saveCurrentConversation();
  };

  const handleChangeSelectionReset = () => {
    // Create new cycle ID
    const newCycleId = `cycle-${Date.now()}`;

    // Create search parameters entry
    const searchParamsEntry = {
      type: "searchParameters",
      timestamp: new Date(),
      cycleId: newCycleId,
      messageId: `${newCycleId}-search-params-${Date.now()}`,
      searchType: searchType, // Keep current search type
      showSearchParams: true,
    };

    // Add ONLY the search parameters, don't modify any existing messages
    setMessages((prevMessages) => [...prevMessages, searchParamsEntry]);

    // Update states
    setConversationCycleId(newCycleId);
    setShowSearchParams(true);
    setHideInitialMessages(true);
    setAskAnotherQueryClicked(true);
    setShowYesSelection(false);
    setUserInput("");
    setIsSendButtonDisabled(true);
    setIsProcessingChangeSelection(false);

    // Save conversation state
    saveCurrentConversation();

    // Reset only the search-related states, preserve the form values
    // Don't call resetSearchState as it might interfere with messages
    setIsLoadingVin(false);
    setIsLoadingModelClass(false);
    setModelClassError("");
    setGroups([]);
    setSubGroups([]);
    setGroupDropdownOpen(false);
    setSubGroupDropdownOpen(false);
    setIsLoadingSubGroups(false);
    setShowPromptSuggestion(false);

    // Scroll to bottom
    setTimeout(scrollToBottom, 200);
  };

  const handleYesSelectionOption = (option) => {
  // Hide all previous interactive elements first
  setMessages((prevMessages) =>
    prevMessages.map((msg) => {
      if (msg.showYesSelection) {
        return {
          ...msg,
          optionSelected: true,
          hideButtons: true,
        };
      }
      if (msg.sender === "assistant" && !msg.hideFeedbackButtons) {
        return {
          ...msg,
          hideFeedbackButtons: true,
        };
      }
      // Hide Ask Another Query button
      if (msg.isFollowUp) {
        return {
          ...msg,
          showAskAnotherQueryButton: false,
        };
      }
      return msg;
    })
  );

  const optionMessage = {
    textKey: option === "rephrase" ? "rephraseQues" : "changeSelection",
    timestamp: new Date(),
    cycleId: conversationCycleId,
    messageId: `${conversationCycleId}-yes-option-${Date.now()}`,
    sender: "user",
    isYesOption: true,
  };

  if (option === "rephrase") {
    // Add the option message
    setMessages((prevMessages) => [...prevMessages, optionMessage]);
    
    setIsSendButtonDisabled(false);
    // Add assistant response for "Rephrase question" option with component flag
    const assistantResponseMessage = {
      textKey: "gotItMessage",
      timestamp: new Date(),
      cycleId: conversationCycleId,
      messageId: `${conversationCycleId}-assistant-rephrase-${Date.now()}`,
      sender: "assistant",
      isRephraseResponse: true,
      showRephraseQuestion: true, // Flag to show the RephraseQuestion component
    };
    setMessages((prevMessages) => [
      ...prevMessages,
      assistantResponseMessage,
    ]);

    setUserInput("");
  } else if (option === "change") {
    // SIMPLIFIED APPROACH: Add all messages at once and don't use timeouts
    
    const assistantMessage = {
      textKey: "noWorriesMessage",
      timestamp: new Date(),
      cycleId: conversationCycleId,
      messageId: `${conversationCycleId}-assistant-change-${Date.now()}`,
      sender: "assistant",
      isChangeSelectionResponse: true,
    };
    
    // Create new cycle ID for search parameters
    const newCycleId = `cycle-${Date.now()}`;
    
    const searchParamsEntry = {
      type: "searchParameters",
      timestamp: new Date(),
      cycleId: newCycleId,
      messageId: `${newCycleId}-search-params-${Date.now()}`,
      searchType: searchType,
      showSearchParams: true,
    };
    
    // Add ALL messages at once - no delays, no timeouts
    setMessages((prevMessages) => [
      ...prevMessages,
      optionMessage,        // User's "Change selections" message
      assistantMessage,     // "No worries!" message
      searchParamsEntry     // Search parameters component
    ]);
    
    // Update all states immediately
    setConversationCycleId(newCycleId);
    setShowSearchParams(true);
    setHideInitialMessages(true);
    setAskAnotherQueryClicked(true);
    setShowYesSelection(false);
    setUserInput("");
    setIsSendButtonDisabled(true);
    setIsProcessingChangeSelection(false);
    
    // Reset search-related states
    setIsLoadingVin(false);
    setIsLoadingModelClass(false);
    setModelClassError("");
    setGroups([]);
    setSubGroups([]);
    setGroupDropdownOpen(false);
    setSubGroupDropdownOpen(false);
    setIsLoadingSubGroups(false);
    setShowPromptSuggestion(false);
    
    // Save conversation state
    saveCurrentConversation();
    
    // Scroll to bottom after a short delay
    setTimeout(scrollToBottom, 100);
  }
};

  const addInitialSystemMessage = () => {
    // Only add if all required fields are filled
    if (!areAllRequiredFieldsFilled() || hasValidationError) {
      return;
    }

    const initialMessage = {
      // text: "All set! Type your question and let Shop Manual Chatbot assist you.",
      text: t("allSetMessageShop"),
      // text: t("allSetMessage"),
      timestamp: new Date(),
      cycleId: conversationCycleId,
      messageId: `${conversationCycleId}-assistant-initial-${Date.now()}`,
      sender: "assistant",
      isInitialMessage: true,
    };

    // Check if this initial message already exists to avoid duplicates
    const initialMessageExists = messages.some(
      (msg) => msg.isInitialMessage && msg.cycleId === conversationCycleId
    );

    if (!initialMessageExists) {
      // Add to messages array (single source of truth)
      setMessages((prevMessages) => [...prevMessages, initialMessage]);
      setTimeout(scrollToBottom, 100);
    }
  };
  // Refs for detecting clicks outside dropdowns
  const groupDropdownRef = useRef(null);
  const subGroupDropdownRef = useRef(null);

  useEffect(() => {
    if (modelInput.trim() || classificationInput.trim()) {
      if (debounceTimer) clearTimeout(debounceTimer);

      // Set new timer to call API after 2 seconds of inactivity
      const timer = setTimeout(() => {
        // lookupByModelAndClassification(modelInput, classificationInput);
      }, 400);
      setDebounceTimer(timer);
    }
    return () => clearTimeout(debounceTimer);
  }, [modelInput, classificationInput]);

  const sendFinalQuery = async (query) => {
    try {
      // Always use English country name for API, regardless of display language
      const countryNameForAPI = selectedCountry?.nameEN || selectedCountry?.name || "";
      const countryCodeForAPI = selectedCountry?.nameEN ? selectedCountry.nameEN.substring(0, 2).toUpperCase() : (selectedCountry?.code || "");

      const requestBody = {
        user_query: query,
        chat_id: chatId || "",
        user_id:
          sessionStorage.getItem("user_id") ||
          localStorage.getItem("user_id") ||
          "",
        vin: vinInput || "",
        model: modelInput || "",
        publication_name: selectedPublication?.name || "",
        country: countryNameForAPI,
        country_code: countryCodeForAPI,
        month: selectedMonth !== null ? selectedMonth + 1 : "",
        year: selectedYear || "",
        publication_number: publicationNumber || "",
        language: selectedLanguage, // ADD THIS LINE
      };

      const response = await fetch(`${CHAT_API_ENDPOINTS.SHOP_MANUAL_CHAT}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      if (data && data.chat_id) {
        setChatId(data.chat_id);
      }
      return data;
    } catch (error) {
      console.error("Error sending final query:", error);
      return null;
    }
  };

  const handleModelInputChange = (e) => {
    const value = e.target.value;
    setModelInput(value);
    setIsValidModelClass(false);
  };

  const handleClassificationInputChange = (e) => {
    const value = e.target.value;
    setClassificationInput(value);
    setIsValidModelClass(false);
  };

  const handleVinInputChange = (e) => {
    const value = e.target.value;
    setVinInput(value);
    if (vinTimeoutRef.current) {
      clearTimeout(vinTimeoutRef.current);
    }

    // Set a new timeout - only call API when user stops typing for 400ms
    if (value.length >= 0) {
      setIsValidVin(true);
      setVinError("");
    } else {
      setIsValidVin(false);
      if (value.length > 0) {
        setVinError("VIN must be at least 8 characters");
      } else {
        setVinError("");
      }
    }
  };

  const handleGroupSelect = (selectedOption) => {
    const [groupName, mainGroup] = selectedOption.split("|");
    setSelectedGroup(groupName);
    setSelectedGroupMainGroup(mainGroup);

    // setSelectedSubGroup("");
    // if (searchType === "vin" && isValidVin) {
    //   fetchSubGroups(vinInput, mainGroup);
    // } else if (searchType === "model" && isValidModelClass) {
    //   fetchSubGroups("", mainGroup);
    // }
  };

  const handleSubGroupSelect = (selectedOption) => {
    const [selectedSubGroupName, selectedSubGroupGroup] =
      selectedOption.split("|");
    setSelectedSubGroup(selectedSubGroupName);
    setSelectedSubGroupMainGroup(selectedSubGroupGroup);

    setIsSendButtonDisabled(false);
    setShowPromptSuggestion(true);
    const randomIndex = Math.floor(Math.random() * promptSuggestions.length);
    setSelectedPromptIndex(randomIndex);

    setMessages((prevMessages) =>
      prevMessages.filter((msg) => !(msg.type === "promptSuggestion"))
    );

    setTimeout(scrollToBottom, 100);
  };

  const handlePromptSuggestionSelect = (suggestion, messageId) => {
    setMessages((prevMessages) =>
      prevMessages.map((msg) => {
        if (msg.sender === "assistant" && !msg.hideFeedbackButtons) {
          return {
            ...msg,
            hideFeedbackButtons: true,
          };
        }
        if (msg.showYesSelection) {
          return {
            ...msg,
            hideButtons: true,
            optionSelected: true,
          };
        }

        // Hide Ask Another Query button
        if (msg.isFollowUp) {
          return {
            ...msg,
            showAskAnotherQueryButton: false,
          };
        }

        // Hide other prompt suggestions
        if (
          msg.type === "promptSuggestion" &&
          msg.showPromptSuggestion &&
          msg.messageId !== messageId
        ) {
          return {
            ...msg,
            showPromptSuggestion: false,
            dismissed: true,
          };
        }

        return msg;
      })
    );
    setUserInput(suggestion);
    setIsSendButtonDisabled(false);
    setMessages((prevMessages) =>
      prevMessages.map((msg) =>
        msg.messageId === messageId
          ? { ...msg, selected: true, showPromptSuggestion: false }
          : msg
      )
    );

    // Hide the prompt suggestion footer
    setShowPromptSuggestion(false);
    const inputField = document.querySelector(
      'textarea[placeholder="Ask anything..."]'
    );
    if (inputField) {
      inputField.focus();
    }
    setTimeout(scrollToBottom, 100);
  };
  const dismissPromptSuggestion = (messageId) => {
    // Update the messages array to hide the prompt suggestion
    setMessages((prevMessages) =>
      prevMessages.map((msg) =>
        msg.messageId === messageId
          ? { ...msg, dismissed: true, showPromptSuggestion: false }
          : msg
      )
    );
    // Hide the prompt suggestion footer
    setShowPromptSuggestion(false);
  };

  const isSearchValid =
    (searchType === "vin" && isValidVin) ||
    (searchType === "model" && isValidModelClass);

  const handleUserInputChange = (e) => {
    setUserInput(e.target.value);
  };

  const handleSendMessage = async () => {
    // Check for empty input
    if (userInput.trim() === "") {
      const inputField = document.querySelector(
        'textarea[placeholder="Ask anything..."]'
      );
      if (inputField) {
        inputField.classList.add("error-input");

        const existingError = document.querySelector(".input-error-message");
        if (!existingError) {
          const errorMessage = document.createElement("div");
          errorMessage.className = "input-error-message";
          errorMessage.textContent = "Please type a message";
          inputField.parentNode.parentNode.appendChild(errorMessage);
          setTimeout(() => {
            inputField.classList.remove("error-input");
            errorMessage.remove();
          }, 3000);
        }
      }
      return;
    }

    if (hasValidationError) {
      return;
    }

    if (isSendButtonDisabled) return;

    // Stop speech recognition if active
    if (isListening && speechRecognition) {
      speechRecognition.stop();
      setIsListening(false);
    }

    setShowYesSelection(false);
    setHideInitialMessages(true);
    setShowSearchParams(false);
    setShowPromptSuggestion(false);

    setMessages((prevMessages) =>
      prevMessages.filter((msg) => !msg.isInitialMessage)
    );

    // Hide previous UI elements
    setMessages((prevMessages) =>
      prevMessages.map((msg) => {
        // Hide feedback buttons
        if (msg.sender === "assistant" && !msg.hideFeedbackButtons) {
          return { ...msg, hideFeedbackButtons: true };
        }
        // Hide YesSelection buttons
        if (msg.showYesSelection) {
          return { ...msg, hideButtons: true };
        }
        // Hide Ask Another Query button
        if (msg.isFollowUp) {
          return { ...msg, showAskAnotherQueryButton: false };
        }
        return msg;
      })
    );

    // Create user message with all search info
    const newUserMessage = {
      text: userInput,
      timestamp: new Date(),
      cycleId: conversationCycleId,
      messageId: `${conversationCycleId}-user-${Date.now()}`,
      sender: "user",
      searchInfo: {
        vin: vinInput || "",
        model: modelInput || "",
        classification: classificationInput || "",
        mainGroup: selectedGroupMainGroup || "",
        subGroup: selectedSubGroup || "",
        publicationName: selectedPublication?.name || "",
        country: selectedCountry?.name || "",
        countryCode: selectedCountry?.code || "",
        month: selectedMonth !== null ? selectedMonth + 1 : "",
        year: selectedYear || "",
        publicationNumber: publicationNumber || "",
      },
    };

    // Update messages
    setMessages((prevMessages) => {
      const updatedMessages = prevMessages.filter(
        (msg) => !(msg.type === "searchParameters" || msg.isInitialMessage)
      );
      return [...updatedMessages, newUserMessage];
    });

    setUserMessages((prevUserMessages) => [
      ...prevUserMessages,
      newUserMessage,
    ]);
    setShowUserPart(true);
    setAskAnotherQueryClicked(false);
    setUserInput("");
    setIsThinking(true);

    try {
      // Make API call with all fields
      const response = await sendFinalQuery(newUserMessage.text);

      setIsThinking(false);

      if (response) {
        const newAssistantMessage = {
          text: response.response || "I don't have related information",
          timestamp: new Date(),
          cycleId: conversationCycleId,
          messageId: `${conversationCycleId}-assistant-${Date.now()}`,
          sender: "assistant",
          chatId: response.chat_id,
          chat_record_id: response.chat_record_id,
          user_feedback: response.user_feedback,
          imageLinks: response.image_link
            ? response.image_link.map((img) => `data:image/jpeg;base64,${img}`)
            : [],
          pdf_link: response.pdf_link || null,
        };
        setMessages((prevMessages) => [...prevMessages, newAssistantMessage]);

        if (response.chat_id) {
          setChatId(response.chat_id);
        }
      }
    } catch (error) {
      console.error("Error sending query:", error);
      setIsThinking(false);
    } finally {
      // Fetch chat history after a delay
      setTimeout(() => {
        fetchChatHistory();
      }, 300);
    }

    scrollToBottom();
  };

  // Handle key press for sending message with Enter key
  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();

      // Check all the same conditions as the send button
      if (
        hasValidationError ||
        isSendButtonDisabled ||
        !userInput.trim() ||
        isThinking ||
        isViewingHistory
      ) {
        return;
      }

      handleSendMessage();
    }
  };

  // Updated handleResetQuery function to work for both new chats and history views
  const handleResetQuery = (isChangeSelection = false) => {
    // Don't handle change selection here at all
    if (isChangeSelection || isProcessingChangeSelection) {
      return;
    }

    if (isListening && speechRecognition) {
      speechRecognition.stop();
      setIsListening(false);
    }
    setUserInput("");
    setIsViewingHistory(false);

    // Clear all values for new queries
    setSelectedPublication(null);
    setSelectedCountry(null);
    setSelectedMonth(null);
    setSelectedYear(null);
    setPublicationNumber("");
    setVinInput("");
    setModelInput("");
    setClassificationInput("");
    setSearchType("");
    setSelectedGroup("");
    setSelectedGroupMainGroup("");
    setSelectedSubGroup("");
    setSelectedSubGroupMainGroup("");

    setIsSendButtonDisabled(true);

    // Hide interactive elements but NEVER touch static messages
    setMessages((prevMessages) =>
      prevMessages.map((msg) => {
        // NEVER modify static messages
        if (msg.isStatic) {
          return msg;
        }

        // Hide any Yes/No feedback buttons
        if (msg.sender === "assistant" && !msg.hideFeedbackButtons) {
          return {
            ...msg,
            hideFeedbackButtons: true,
          };
        }

        // Hide YesSelection buttons
        if (msg.showYesSelection) {
          return {
            ...msg,
            hideButtons: true,
            optionSelected: true,
          };
        }

        // Hide Ask Another Query button
        if (msg.isFollowUp) {
          return {
            ...msg,
            showAskAnotherQueryButton: false,
            hideAskAnotherQueryButton: true,
          };
        }

        // Hide prompt suggestions
        if (msg.type === "promptSuggestion" && msg.showPromptSuggestion) {
          return {
            ...msg,
            showPromptSuggestion: false,
            dismissed: true,
          };
        }

        return msg;
      })
    );

    saveCurrentConversation();
    const newCycleId = `cycle-${Date.now()}`;
    setConversationCycleId(newCycleId);

    // Reset search state completely for new queries
    resetSearchState(false);

    const searchParamsEntry = {
      type: "searchParameters",
      timestamp: new Date(),
      cycleId: newCycleId,
      messageId: `${newCycleId}-search-params-${Date.now()}`,
      searchType: "", // Empty for new queries
      showSearchParams: true,
    };
    setMessages((prevMessages) => [...prevMessages, searchParamsEntry]);

    setShowSearchParams(true);
    setHideInitialMessages(true);
    setAskAnotherQueryClicked(true);
    setShowYesSelection(false);
    setUserInput("");

    setVinError("");
    setModelClassError("");
    setIsLoadingVin(false);
    setIsLoadingModelClass(false);
    setIsLoadingSubGroups(false);

    setGroupDropdownOpen(false);
    setSubGroupDropdownOpen(false);
    setTimeout(scrollToBottom, 100);
    setShowPromptSuggestion(false);
  };

  const resetSearchState = (preserveValues = false) => {
    // Don't do anything if we're processing change selection
    if (isProcessingChangeSelection) {
      return;
    }

    if (!preserveValues) {
      setSearchInput({
        vin: "",
        model: "",
        classification: "",
      });
      setVinError("");
      setModelClassError("");
      setIsValidVin(false);
      setIsValidModelClass(false);
      setGroups([]);
      setSubGroups([]);
      setVinInput("");
      setModelInput("");
      setClassificationInput("");
      setSelectedSubGroup("");
      setSelectedSubGroupMainGroup("");
      setSelectedGroup("");
      setSelectedGroupMainGroup("");
      setSelectedPublication(null);
      setSelectedCountry(null);
      setSelectedMonth(null);
      setSelectedYear(null);
      setPublicationNumber("");
    }

    // Always reset these states regardless
    setIsLoadingVin(false);
    setIsLoadingModelClass(false);
    setModelClassError("");
    setGroups([]);
    setSubGroups([]);
    setGroupDropdownOpen(false);
    setSubGroupDropdownOpen(false);
    setIsLoadingSubGroups(false);

    // Clear text area input
    setUserInput("");

    // Reset validation state only if not preserving values
    if (!preserveValues) {
      setHasValidationError(false);

      // Call validation change handler
      if (handleValidationChange) {
        handleValidationChange(true); // Reset to invalid state initially
      }
    }
  };

  const resetToWelcomePage = () => {
    if (isListening && speechRecognition) {
      speechRecognition.stop();
      setIsListening(false);
    }

    // Clear the textarea
    setIsViewingHistory(false);
    setUserInput("");
    setIsChatStarted(false);
    setChatId(null);
    setSelectedHistoryId(null);
    setIsSendButtonDisabled(true);
    setShowQueriesInChat(false);
    setUserMessages([]);
    setAssistantMessages([]);
    setMessages([]);
    resetSearchState();
    setShowSearchParams(false);
    setHideInitialMessages(false);
    setAskAnotherQueryClicked(false);
    setShowYesSelection(false);
    const newCycleId = `cycle-${Date.now()}`;
    setConversationCycleId(newCycleId);
    setShowPromptSuggestion(false);
  };

  //Chat History Section
  const userId =
    sessionStorage.getItem("user_id") ||
    localStorage.getItem("user_id") ||
    userId ||
    "";

  const getUTCDateParts = (date) => {
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth(),
      day: date.getUTCDate(),
    };
  };

  // Compare two dates for same day (ignoring time)
  const isSameUTCDay = (date1, date2) => {
    const d1 = getUTCDateParts(date1);
    const d2 = getUTCDateParts(date2);

    return d1.year === d2.year && d1.month === d2.month && d1.day === d2.day;
  };

  const fetchChatHistory = async () => {
    const sidebarElement = document.querySelector(".sidebarPnc");
    if (sidebarElement) {
      sidebarElement.classList.add("loading");
    }
    const historyContainer = document.querySelector(".historyTabPnc");
    const scrollPosition = historyContainer ? historyContainer.scrollTop : 0;

    try {
      setIsLoadingHistory(false);

      const response = await fetch(
        `${CHAT_API_ENDPOINTS.SHOP_MANUAL_GET_CHAT_HISTORY_LIST}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            // user_id: userId,
            user_id:
              sessionStorage.getItem("user_id") ||
              localStorage.getItem("user_id") ||
              userId ||
              "",
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch chat history");
      }

      const data = await response.json();

      // Check for the specific error response structure
      if (
        data &&
        data.status === false &&
        data.message === "data for this user id not found"
      ) {
        // Set empty arrays to represent no history
        setPinnedChats([]);
        setChatHistory([]);
      } else if (data) {
        const historyArray = Object.values(data);
        const historyWithTimestamps = historyArray.map((item) => {
          const date = new Date(item.time_stamp);
          return {
            ...item,
            timestamp: date,
            dateString: date.toLocaleString(),
          };
        });

        // Sort history in descending order (newest first)
        historyWithTimestamps.sort((a, b) => {
          const timeA = b.timestamp.getTime();
          const timeB = a.timestamp.getTime();

          if (timeA !== timeB) {
            return timeA - timeB;
          }
          // Secondary sort by ID to ensure consistent ordering
          const idA = a.chat_id || a.title_id || "";
          const idB = b.chat_id || b.title_id || "";
          return idB.localeCompare(idA);
        });
        // Find pinned chats based on the pinned: 1 flag
        const pinnedItems = historyWithTimestamps.filter(
          (item) => item.pinned === 1
        );

        // Also sort pinned items by time (newest first)
        pinnedItems.sort((a, b) => b.timestamp - a.timestamp);

        // Update states with minimal UI disruption
        setPinnedChats(pinnedItems);
        setChatHistory(historyWithTimestamps);
      } else {
        setPinnedChats([]);
        setChatHistory([]);
      }

      // Restore scroll position after state updates
      setTimeout(() => {
        if (historyContainer) {
          historyContainer.scrollTop = scrollPosition;
        }
      }, 50);
    } catch (error) {
      console.error("Error fetching chat history:", error);
      // Instead of setting an error message, set empty arrays
      setPinnedChats([]);
      setChatHistory([]);
      // setHistoryError("Failed to load chat history");
    } finally {
      setIsLoadingHistory(false);
      if (sidebarElement) {
        setTimeout(() => {
          sidebarElement.classList.remove("loading");
        }, 100);
      }
    }
  };

  const togglePinStatus = async (historyItem, e) => {
    e.stopPropagation();
    const chatId = historyItem.chat_id || historyItem.title_id;

    if (!chatId) {
      console.error("Missing chat_id in history item");
      return;
    }
    const isPinned = historyItem.pinned === 1;
    const newPinStatus = isPinned ? 0 : 1;

    // console.log(
    //   `${
    //     isPinned ? "Unpinning" : "Pinning"
    //   } chat with ID: ${chatId}, setting pinned=${newPinStatus}`
    // );

    // Store current state for potential rollback
    const currentPinnedChats = [...pinnedChats];
    const currentChatHistory = [...chatHistory];

    try {
      if (newPinStatus === 1) {
        const updatedItem = { ...historyItem, pinned: 1 };
        setPinnedChats((prev) => [...prev, updatedItem]);
        setChatHistory((prev) =>
          prev.map((item) =>
            (item.chat_id || item.title_id) === chatId
              ? { ...item, pinned: 1 }
              : item
          )
        );
      } else {
        setPinnedChats((prev) =>
          prev.filter((item) => (item.chat_id || item.title_id) !== chatId)
        );
        setChatHistory((prev) =>
          prev.map((item) =>
            (item.chat_id || item.title_id) === chatId
              ? { ...item, pinned: 0 }
              : item
          )
        );
      }

      // Close the dropdown
      setActiveDropdownId(null);

      // Now make the API call
      const response = await fetch(CHAT_API_ENDPOINTS.SHOP_MANUAL_PIN_CHAT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          chat_id: chatId,
          user_id:
            sessionStorage.getItem("user_id") ||
            localStorage.getItem("user_id") ||
            userId ||
            "",
          pinned: newPinStatus,
        }),
      });
      if (!response.ok) {
        const errorText = await response.text();
        console.error("API error response:", errorText);
        throw new Error(`API returned ${response.status}: ${errorText}`);
      }
      const data = await response.json();
      // console.log("API call successful, response:", data);
    } catch (error) {
      console.error("Error in togglePinStatus:", error.message);

      setPinnedChats(currentPinnedChats);
      setChatHistory(currentChatHistory);

      alert(`Failed to ${isPinned ? "unpin" : "pin"} chat. Please try again.`);
    }
  };

  // These two handler functions use the same togglePinStatus function
  const handlePinChat = (historyItem, e) => {
    // console.log("handlePinChat called");
    togglePinStatus(historyItem, e);
  };

  // Fixed delete button click handler
  const handleDeleteButtonClick = (item, e) => {
    e.preventDefault();
    e.stopPropagation();

    setDeleteItemInfo(item);
    setIsDeleteModalOpen(true);
    setActiveDropdownId(null);
  };

  const handleConfirmDelete = () => {
    if (!deleteItemInfo) return;

    const chatId = deleteItemInfo.chat_id || deleteItemInfo.title_id;
    if (!chatId) {
      console.error("Missing chat_id in history item");
      setIsDeleteModalOpen(false);
      return;
    }

    deleteChat(deleteItemInfo, chatId);
    setIsDeleteModalOpen(false);
  };

  // Delete chat API function
  const deleteChat = async (item, chatId) => {
    try {
      // console.log("Deleting chat with ID:", chatId);

      // Make API call to delete chat
      const response = await fetch(
        `${CHAT_API_ENDPOINTS.SHOP_MANUAL_DELETE_CHAT_HISTORY}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            chat_id: chatId,
            user_id:
              sessionStorage.getItem("user_id") ||
              localStorage.getItem("user_id") ||
              userId ||
              "",
          }),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Delete API error:", errorText);
        throw new Error(`Failed to delete chat: ${response.status}`);
      }

      const data = await response.json();
      // console.log("Delete chat response:", data);

      // Update both states: pinnedChats and chatHistory
      setPinnedChats((prevChats) =>
        prevChats.filter((chat) => (chat.chat_id || chat.title_id) !== chatId)
      );

      setChatHistory((prevHistory) =>
        prevHistory.filter((chat) => (chat.chat_id || chat.title_id) !== chatId)
      );

      setActiveDropdownId(null);

      if (selectedHistoryId === chatId) {
        resetToWelcomePage();
      }

      // Show success toast
      setToastMessage(t("chatDeletedSuccess"));
      setShowToast(true);

      // Hide toast after 3 seconds
      setTimeout(() => {
        setShowToast(false);
      }, 3000);
    } catch (error) {
      console.error("Error deleting chat:", error);
      alert("Failed to delete chat. Please try again.");
    }
  };

  // Fixed unpin button click handler
  const handleUnpinButtonClick = (item, e) => {
    e.preventDefault();
    e.stopPropagation();

    // console.log("Unpin button clicked for item:", item);

    // Get the chat_id from the history item
    const chatId = item.chat_id || item.title_id;

    if (!chatId) {
      console.error("Missing chat_id in history item");
      return;
    }
    // Call the unpin API
    unpinChat(item, chatId);
  };

  // Unpin chat API function
  const unpinChat = async (item, chatId) => {
    try {
      // console.log("Unpinning chat with ID:", chatId);

      setPinnedChats((prevChats) =>
        prevChats.filter((chat) => (chat.chat_id || chat.title_id) !== chatId)
      );

      setChatHistory((prevHistory) =>
        prevHistory.map((chat) =>
          (chat.chat_id || chat.title_id) === chatId
            ? { ...chat, pinned: 0 }
            : chat
        )
      );
      setActiveDropdownId(null);

      // Make API call to unpin chat
      const response = await fetch(
        `${CHAT_API_ENDPOINTS.SHOP_MANUAL_PIN_CHAT}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            chat_id: chatId,
            user_id: userId,
            pinned: 0, // 0 means unpin
          }),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Unpin API error:", errorText);
        throw new Error(`Failed to unpin chat: ${response.status}`);
      }

      const data = await response.json();
      // console.log("Unpin chat response:", data);
    } catch (error) {
      console.error("Error unpinning chat:", error);
      alert("Failed to unpin chat. Please try again.");
      fetchChatHistory();
    }
  };

  useEffect(() => {
    fetchChatHistory();
  }, []);

  useEffect(() => {
    // Re-sort chat history whenever it changes
    if (chatHistory.length > 0) {
      setChatHistory((prevHistory) => {
        const sortedHistory = [...prevHistory];
        sortedHistory.sort((a, b) => b.timestamp - a.timestamp);
        return sortedHistory;
      });

      setPinnedChats((prevPinned) => {
        const sortedPinned = [...prevPinned];
        sortedPinned.sort((a, b) => b.timestamp - a.timestamp);
        return sortedPinned;
      });
    }
  }, []);

  // Modified handleHistoryItemClick function to sort messages chronologically
  const handleHistoryItemClick = async (historyItem) => {
    if (!historyItem) {
      console.error("Invalid history item");
      return;
    }

    const chatId = historyItem.chat_id || historyItem.title_id;

    if (!chatId) {
      console.error("Missing chat_id/title_id in history item");
      return;
    }

    try {
      // console.log("Clicked history item:", historyItem);
      setIsSendButtonDisabled(true);
      setIsViewingHistory(true);
      setSelectedHistoryId(chatId);
      setShowQueriesInChat(true);
      setShowPromptSuggestion(false);
      setMessages((prevMessages) =>
        prevMessages.map((msg) => {
          if (msg.sender === "assistant" && !msg.hideFeedbackButtons) {
            return {
              ...msg,
              hideFeedbackButtons: true,
            };
          }

          // Hide YesSelection buttons
          if (msg.showYesSelection) {
            return {
              ...msg,
              hideButtons: true,
              optionSelected: true,
            };
          }

          // Hide Ask Another Query button
          if (msg.isFollowUp) {
            return {
              ...msg,
              showAskAnotherQueryButton: false,
            };
          }

          // Hide prompt suggestions
          if (msg.type === "promptSuggestion" && msg.showPromptSuggestion) {
            return {
              ...msg,
              showPromptSuggestion: false,
              dismissed: true,
            };
          }

          return msg;
        })
      );

      const response = await fetch(
        CHAT_API_ENDPOINTS.SHOP_MANUAL_GET_CHAT_HISTORY_DETAILS,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            chat_id: chatId,
            user_id:
              sessionStorage.getItem("user_id") ||
              localStorage.getItem("user_id") ||
              userId ||
              "",
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch conversation details");
      }

      const conversationData = await response.json();
      // console.log("Raw conversation data:", conversationData);

      setIsChatStarted(true);
      const historyCycleId = `history-${Date.now()}`;
      setConversationCycleId(historyCycleId);
      setChatId(chatId);
      setMessages([]);

      let processedMessages = [];

      if (conversationData && typeof conversationData === "object") {
        const items = Object.values(conversationData);

        // Sort items by timestamp (oldest first)
        items.sort((a, b) => {
          const timeA = new Date(a.time_stamp || 0).getTime();
          const timeB = new Date(b.time_stamp || 0).getTime();
          return timeA - timeB;
        });

        items.forEach((item, index) => {
          // First add user message if it exists
          if (item.user_question) {
            processedMessages.push({
              text: item.user_question,
              timestamp: new Date(item.time_stamp || Date.now()),
              cycleId: historyCycleId,
              messageId: `${historyCycleId}-user-${index}`,
              sender: "user",
            });
          }

          // Then add assistant message if it exists
          if (item.ai_response) {
            processedMessages.push({
              text: item.ai_response,
              timestamp: new Date(item.time_stamp || Date.now()),
              cycleId: historyCycleId,
              messageId: `${historyCycleId}-assistant-${index}`,
              sender: "assistant",
              chatId: chatId,
              chat_record_id: item.chat_record_id,
              user_feedback: item.user_feedback,
              isHistoryView: true,
              hideFeedbackButtons: true,
              imageLinks: Array.isArray(item.images)
                ? item.images.map((img) => `data:image/jpeg;base64,${img}`)
                : [],
              pdf_link: item.pdf_link || null,
            });
          }
        });

        // Add a final end message with the "Ask another query" button
        processedMessages.push({
          text: "Awesome! If you ever need more info, just start a new chat. Have a great day!",
          timestamp: new Date(),
          cycleId: historyCycleId,
          messageId: `${historyCycleId}-end-message-${Date.now()}`,
          sender: "assistant",
          isFollowUp: true,
          showAskAnotherQueryButton: true,
        });
      }

      // console.log("Processed messages:", processedMessages);

      if (processedMessages.length > 0) {
        setShowSearchParams(false);
        setHideInitialMessages(true);
        setShowUserPart(true);
        setIsSendButtonDisabled(true);
        setMessages(processedMessages);
        setAskAnotherQueryClicked(false);
      } else {
        console.warn("No messages found in history response");
        alert("No conversation history found. Starting a new chat.");
        handleStartChat();
      }
    } catch (error) {
      console.error("Error loading conversation from history:", error);
      alert("Failed to load conversation history. Please try again.");
    }
  };

  const areAllRequiredFieldsFilled = () => {
    if (searchType === "vin") {
      // VIN: need valid VIN and publication name
      const hasValidVin = vinInput.trim().length > 0 && isValidVin;
      const hasPublication = selectedPublication !== null;
      return hasValidVin && hasPublication;
    } else if (searchType === "model") {
      // Model: need model, publication, country, and calendar (month/year)
      const hasValidModel = modelInput.trim().length > 0;
      const hasPublication = selectedPublication !== null;
      const hasCountry = selectedCountry !== null;
      const hasCalendar = selectedMonth !== null && selectedYear !== null;
      return hasValidModel && hasPublication && hasCountry && hasCalendar;
    } else if (searchType === "publication") {
      // Publication Number: need publication number
      const hasPublicationNumber = publicationNumber.trim().length > 0;
      return hasPublicationNumber;
    }
    return false;
  };

  return (
    <div>
      <div
        className={`bg-gray-50 min-h-screen flex relative overflow-hidden pncMainPart ${
          isSidebarOpen ? "sidebar-open" : "sidebar-closed"
        }`}
      >
        {/* Sidebar */}
        <div className="leftSideBarPnc">
          <Sidebar
            isSidebarOpen={isSidebarOpen}
            toggleSidebar={toggleSidebar}
            resetToWelcomePage={resetToWelcomePage}
            toggleFeedbackModal={toggleFeedbackModal}
            chatHistory={chatHistory}
            pinnedChats={pinnedChats}
            selectedHistoryId={selectedHistoryId}
            handleHistoryItemClick={handleHistoryItemClick}
            isLoadingHistory={isLoadingHistory}
            historyError={historyError}
            toggleDropdown={toggleDropdown}
            activeDropdownId={activeDropdownId}
            handleDeleteButtonClick={handleDeleteButtonClick}
            handlePinChat={handlePinChat}
            handleUnpinButtonClick={handleUnpinButtonClick}
            toggleAboutModal={toggleAboutModal} // Make sure this is included and is a function
            handleLogout={handleLogout}
          />
        </div>
        {/* Main Content */}
        <div className="flex-1 flex-col bg-[#FFFFFF] h-screen">
          <Header
            isSidebarOpen={isSidebarOpen}
            toggleSidebar={toggleSidebar}
            resetToWelcomePage={resetToWelcomePage}
            toggleAboutModal={toggleAboutModal}
            showQueriesInChat={showQueriesInChat}
            isQueriesDropdownOpen={isQueriesDropdownOpen}
            setIsQueriesDropdownOpen={setIsQueriesDropdownOpen}
            handleSelectPastQuery={handleSelectPastQuery}
            isLogoutDropdownOpen={isLogoutDropdownOpen}
            setIsLogoutDropdownOpen={setIsLogoutDropdownOpen}
            handleLogout={handleLogout}
            messages={messages}
            selectedLanguage={selectedLanguage}
            showLanguageMenu={showLanguageMenu}
            setShowLanguageMenu={setShowLanguageMenu}
            languageOptions={languageOptions}
            handleLanguageChange={handleLanguageChange}
          />
          <Main
            // Chat state
            isChatStarted={isChatStarted}
            handleStartChat={handleStartChat}
            messages={messages}
            isThinking={isThinking}
            dots={dots}
            conversationCycleId={conversationCycleId}
            // Search parameters
            showSearchParams={showSearchParams}
            searchType={searchType}
            setSearchType={setSearchType}
            isSearchValid={isSearchValid}
            // VIN input
            vinInput={vinInput}
            handleVinInputChange={handleVinInputChange}
            isLoadingVin={isLoadingVin}
            vinError={vinError}
            // Model & Classification input
            modelInput={modelInput}
            classificationInput={classificationInput}
            handleModelInputChange={handleModelInputChange}
            handleClassificationInputChange={handleClassificationInputChange}
            isLoadingModelClass={isLoadingModelClass}
            modelClassError={modelClassError}
            // Groups & Subgroups
            groups={groups}
            subGroups={subGroups}
            selectedGroup={selectedGroup}
            selectedGroupMainGroup={selectedGroupMainGroup}
            selectedSubGroup={selectedSubGroup}
            selectedSubGroupMainGroup={selectedSubGroupMainGroup}
            groupDropdownOpen={groupDropdownOpen}
            subGroupDropdownOpen={subGroupDropdownOpen}
            setGroupDropdownOpen={setGroupDropdownOpen}
            setSubGroupDropdownOpen={setSubGroupDropdownOpen}
            handleGroupSelect={handleGroupSelect}
            handleSubGroupSelect={handleSubGroupSelect}
            isLoadingSubGroups={isLoadingSubGroups}
            resetSearchState={resetSearchState}
            // Message interaction handlers
            handleYesSelectionOption={handleYesSelectionOption}
            handleFeedback={handleFeedback}
            handleResetQuery={handleResetQuery}
            askAnotherQueryClicked={askAnotherQueryClicked}
            // User input
            userInput={userInput}
            handleUserInputChange={handleUserInputChange}
            handleKeyPress={handleKeyPress}
            isSendButtonDisabled={isSendButtonDisabled}
            handleSendMessage={handleSendMessage}
            // Voice input
            isListening={isListening}
            toggleSpeechRecognition={toggleSpeechRecognition}
            // Prompt suggestions
            showPromptSuggestion={showPromptSuggestion}
            selectedPromptIndex={selectedPromptIndex}
            promptSuggestions={promptSuggestions}
            handlePromptSuggestionSelect={handlePromptSuggestionSelect}
            dismissPromptSuggestion={dismissPromptSuggestion}
            handleSelectionChange={handleSelectionChange}
            onValidationChange={handleValidationChange}
            selectedLanguage={selectedLanguage}
          />

        </div>
      </div>

      {showToast && (
        <div className="fixed top-4 right-4 bg-green-500 text-white px-4 py-2 rounded shadow-lg z-50 flex items-center feedsubmitPnc">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 mr-2"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
          {toastMessage}
        </div>
      )}
      <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
        chatTitle={deleteItemInfo?.title || "this conversation"}
      />
      <AboutModal
        isOpen={isAboutModalOpen}
        onClose={() => setIsAboutModalOpen(false)}
      />
      <FeedbackModal
        isOpen={isFeedbackModalOpen}
        onClose={() => setIsFeedbackModalOpen(false)}
        onSubmit={handleFeedbackSubmit}
      />
    </div>
  );
};

export default PncNew;
